/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_New_Source_AddInputs */

const vi_scl_new_source_add = /** @type {(inputs: Scl_New_Source_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm lô nguồn`)
};

/**

* @param {Scl_New_Source_AddInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_new_source_add = /** @type {((inputs?: Scl_New_Source_AddInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_New_Source_AddInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_new_source_add(inputs)
});